export const HERO_MOBILE_MQ = '(max-width: 980px)';

export function isHeroMobileViewport() {
  return window.matchMedia(HERO_MOBILE_MQ).matches;
}
